var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#7635dc",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "none",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.968,19v-14c0,-1.657 1.343,-3 3,-3h7l6,6v11c0,1.657 -1.343,3 -3,3h-10c-1.657,0 -3,-1.343 -3,-3z",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.968,6v-4l6,6h-4c-1.104,0 -2,-0.895 -2,-2z",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,11v4l3,-2z",
    stroke: "#7635dc",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaFile);
export default __webpack_public_path__ + "static/media/MediaFile.9ccc9864f73f103dc21a2d4be3022c7a.svg";
export { ForwardRef as ReactComponent };